import { GETConfig, POSTConfig } from "@/types/common.types";
import { AddTownParams, Town, UpdateTownParams } from "@/types/town.types";
import axios from "axios";

const server_url = process.env.REACT_APP_SERVER_DOMAIN;

export const addTown = async (accessToken: string, params: AddTownParams) => {
	const response = await axios.post(
		`${server_url}case/addtowns`,
		params,
		POSTConfig(accessToken)
	);

	return response.data;
};

export const updateTown = async (
	accessToken: string,
	params: UpdateTownParams
) => {
	const response = await axios.post(
		`${server_url}case/updatetown`,
		params,
		POSTConfig(accessToken)
	);
	return response.data;
};

export const getTowns = async (accessToken: string): Promise<Town[]> => {
	const res = await axios.get(
		`${server_url}case/gettowns`,
		GETConfig(accessToken)
	);
	return res.data;
};

export const getSingleTown = async (
	townid: number,
	accessToken: string
): Promise<Town> => {
	const res = await axios.get(
		`${server_url}case/getsingletown/${townid}`,
		GETConfig(accessToken)
	);
	return res.data[0];
};
